'use client';
import { Alert as SharedAlert } from '@launchstore/shared-puck';
import type { AlertProps } from '@launchstore/shared-puck';
export const Alert: any = SharedAlert;
export type { AlertProps };
export default Alert;
